import { Component, h } from 'preact'
import Phrase from '../../libs/translationsUtils/phrase'
import PostEditor from '../editor/postEditorViaAPI'

interface Props {
  topicId: number,
  isGuest: boolean,
  type: 'productUpdates' | 'ideas'
}

interface State {}

class TopicAddReply extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {}
  }
  render ({ topicId, isGuest, type }: Props) {
    return (
      <div className='box__content qa-reply reply-editor-wrapper'>
        <h3>
          <Phrase p='editor.title.comment' />
        </h3>
        <br />
        <PostEditor
          type={type}
          disableFileAttachments={false}
          topicId={topicId}
          replyId={null}
          isControl={false}
          onSuccess={() => window.location.reload()}
          redirect={false}
          isGuest={isGuest}
        />
      </div>
    )
  }
}

export default TopicAddReply
